const searchFacetDateJsClass = 'js-search-facet-date';
const buttonJsClass = searchFacetDateJsClass + '-button';
const inputStartJsClass = searchFacetDateJsClass + '-input-start';
const inputEndJsClass = searchFacetDateJsClass + '-input-end';

const searchFacetDateElements = document.querySelectorAll('.' + searchFacetDateJsClass) as NodeListOf<HTMLElement>;

const dateRegExp = new RegExp(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d{2}$/);

if (searchFacetDateElements.length > 0) {
    searchFacetDateElements.forEach((searchFacetDateElement) => {
        // We get the button element
        const buttonElement = searchFacetDateElement.querySelector('.' + buttonJsClass) as HTMLSelectElement;
        // We get the input elements
        const inputStartElement = searchFacetDateElement.querySelector('.' + inputStartJsClass) as HTMLSelectElement;
        const inputEndElement = searchFacetDateElement.querySelector('.' + inputEndJsClass) as HTMLSelectElement;

        if (buttonElement && inputStartElement && inputEndElement) {
            // We add a click event listener
            buttonElement.addEventListener('click', () => {
                // We get the urls from the data attributes
                const facetUrl = searchFacetDateElement.dataset.facetUrl;
                const resetUrl = searchFacetDateElement.dataset.resetUrl;

                // We get the start and end date and format them
                const startDate = inputStartElement.value;
                const endDate = inputEndElement.value;

                // We reset or add the filter depending on the dates
                if (!startDate && !endDate) {
                    // We reset the filter
                    window.location.href = resetUrl;
                } else if (startDate && !endDate) {
                    // Start date only
                    // If the format is correct
                    if (dateRegExp.test(startDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', formatDate(startDate)).replace('___TO___', '');
                        window.location.href = urlWithDates;
                    } else {
                        formatAlert();
                    }
                } else if (!startDate && endDate) {
                    // End date only
                    // If the format is correct
                    if (dateRegExp.test(endDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', '').replace('___TO___', formatDate(endDate));
                        window.location.href = urlWithDates;
                    } else {
                        formatAlert();
                    }
                } else if (startDate && endDate) {
                    // Start and end dates
                    // If the format is correct
                    if (dateRegExp.test(startDate) && dateRegExp.test(endDate)) {
                        const urlWithDates = facetUrl.replace('___FROM___', formatDate(startDate)).replace('___TO___', formatDate(endDate));
                        window.location.href = urlWithDates;
                    } else {
                        formatAlert();
                    }
                }
            });
        }
    });
}

/** Format dates for Solr facet. */
function formatDate (date: string): string {
    if (date) {
        // We remove slashes, reverse the order and add the time
        return date.split('/').reverse().join('') + '0000';
    } else {
        return;
    }
}

function formatAlert (): void {
    alert('Date(s) incorrecte(s), veuillez respecter le format JJ/MM/AAAA.');
}